import { render, staticRenderFns } from "./AutoAttendingTotem.vue?vue&type=template&id=23ef59e3"
import script from "./AutoAttendingTotem.vue?vue&type=script&lang=js"
export * from "./AutoAttendingTotem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports